module.exports = "/src/views/player/help/images/mask.jpg";